import type { DepositWithdrawAssets, OperationType } from '@/shared/types';

export const hasOperationMethodData = (
  data: DepositWithdrawAssets | undefined,
  methodKey: string,
  assetCode?: string
): boolean => {
  if (!data) return false;

  const [operationType, method] = methodKey.split('.') as [
    OperationType,
    string,
  ];

  if (operationType !== 'deposit' && operationType !== 'withdraw') {
    return true;
  }

  const section = data[operationType];

  if (method === 'crypto') {
    return section.crypto.some(
      network =>
        network.assets.length > 0 &&
        (!assetCode || network.assets.some(asset => asset.code === assetCode))
    );
  }

  return section.fiat.some(item => {
    const params = (item as Record<string, unknown>)[method];
    return Array.isArray(params) && params.length > 0;
  });
};
